import { render } from "./HomeHome.vue?vue&type=template&id=4620fe80&scoped=true"
import script from "./HomeHome.vue?vue&type=script&lang=js"
export * from "./HomeHome.vue?vue&type=script&lang=js"

import "./HomeHome.vue?vue&type=style&index=0&id=4620fe80&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4620fe80"]])

export default __exports__